export enum LexiconMaterialEvent {
    DISPLAY_INFORMATION = 'lexiconMaterial:displayInformation'
}
